import Api from '@/services/Api'
import ApiDownloadReporte from '@/services/Api'

const HEADERURL = 'wms/rutas/';
const ACTION_ADD_DETAIL = 'asignar_tarima_a_contenedor';
const ACTION_DELETE_DETAIL = 'remover_tarima_a_contenedor';
const ACTION_GENERAR_COTIZACION = 'generar_cotizacion';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_REPORTE_PDF = 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },



}